export default "__VITE_ASSET__BaNmUlhh__"